/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Color_Image_Input_OrInputs */

const de_admin_resources_color_image_input_or = /** @type {(inputs: Admin_Resources_Color_Image_Input_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder`)
};

const es_admin_resources_color_image_input_or = /** @type {(inputs: Admin_Resources_Color_Image_Input_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o`)
};

const fr_admin_resources_color_image_input_or = /** @type {(inputs: Admin_Resources_Color_Image_Input_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou`)
};

/** @type {(inputs: Admin_Resources_Color_Image_Input_OrInputs) => LocalizedString} */
const en_admin_resources_color_image_input_or = () => /** @type {LocalizedString} */ ('admin.resources.color_image_input.or')

/** @type {(inputs: Admin_Resources_Color_Image_Input_OrInputs) => LocalizedString} */
const it_admin_resources_color_image_input_or = en_admin_resources_color_image_input_or;

/** @type {(inputs: Admin_Resources_Color_Image_Input_OrInputs) => LocalizedString} */
const pt_br2_admin_resources_color_image_input_or = en_admin_resources_color_image_input_or;

/** @type {(inputs: Admin_Resources_Color_Image_Input_OrInputs) => LocalizedString} */
const pl_admin_resources_color_image_input_or = en_admin_resources_color_image_input_or;

/** @type {(inputs: Admin_Resources_Color_Image_Input_OrInputs) => LocalizedString} */
const hu_admin_resources_color_image_input_or = en_admin_resources_color_image_input_or;

/** @type {(inputs: Admin_Resources_Color_Image_Input_OrInputs) => LocalizedString} */
const ro_admin_resources_color_image_input_or = en_admin_resources_color_image_input_or;

/**

* @param {Admin_Resources_Color_Image_Input_OrInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_color_image_input_or = /** @type {((inputs?: Admin_Resources_Color_Image_Input_OrInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Color_Image_Input_OrInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_color_image_input_or(inputs)
	if (locale === "de") return de_admin_resources_color_image_input_or(inputs)
	if (locale === "es") return es_admin_resources_color_image_input_or(inputs)
	if (locale === "fr") return fr_admin_resources_color_image_input_or(inputs)
	if (locale === "it") return it_admin_resources_color_image_input_or(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_color_image_input_or(inputs)
	if (locale === "pl") return pl_admin_resources_color_image_input_or(inputs)
	if (locale === "hu") return hu_admin_resources_color_image_input_or(inputs)
	return ro_admin_resources_color_image_input_or(inputs)
});
export { admin_resources_color_image_input_or as "admin.resources.color_image_input.or" }